import { Rows } from "./interfaces";


/**
 * Adjusts the column widths of an array of arrays to fit the content.
 * Each column width is determined by the maximum character length in that column, but not greater than **maxColumnWidth**
 *
 * @param dataArray - The array representing the data.
 * @returns An array of column widths, e.g. [ { width: 10 }, { width: 14 }, { width: 14 } ]
 */
export const fitToColumn = (dataArray: Rows): { width: number }[] => dataArray[0].map((_, columnIndex) => {
  // Calculate the width based on the content length
  let contentWidth = Math.max(
    ...dataArray.map((row) => (row[columnIndex] ? row[columnIndex].toString().length : 0)),
  );

  // Apply the multiplier for additional space
  contentWidth *= multiplierToAddSpace;

  // Apply the minimum and maximum constraints
  const finalWidth = Math.max(minColumnWidth, Math.min(maxColumnWidth, contentWidth));

  return { width: finalWidth };
});



const minColumnWidth = 10;
const maxColumnWidth = 30;
const multiplierToAddSpace = 1.2;
